<template>
    <supplies-form-outside-common></supplies-form-outside-common>
</template>
<script>
import suppliesFormOutsideCommon from './suppliesFormOutsideCommon.vue';

export default {
    name: 'suppliesFormOutsideAdd',
    components: {
        suppliesFormOutsideCommon,
    },
};
</script>
